import React from 'react';
import { Button, Drawer as DrawerCreate, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Controller, Resolver, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAppDispatch, useAppSelector } from 'app/store';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import { UploadFile } from 'shared/ui/UploadComponents';
import { validationSchema } from 'widgets/mechanicDetailPage/model/validationSchema';
import { usePostSKUFileMutation } from 'widgets/mechanicDetailPage/api/getMechanicDetailApi';

type MechanicUploadScuPropsType = {
  id: string | undefined;
};

type DefaultValuesSkuType = {
  file: File | null;
};

export const MechanicUploadScu = ({ id }: MechanicUploadScuPropsType) => {
  const dispatch = useAppDispatch();

  const { isDrawerOpen } = useAppSelector((state) => state.ui);
  const [createSKURequest] = usePostSKUFileMutation();

  const {
    control,
    handleSubmit,
    formState: { errors = {} } = {},
    reset,
  } = useForm<DefaultValuesSkuType>({
    mode: 'onChange',
    resolver: yupResolver(validationSchema) as Resolver<DefaultValuesSkuType>,
    defaultValues: {
      file: null,
    },
  });

  const onCloseDrawer = () => {
    reset();
    dispatch(setDrawerOpen(false));
  };

  const onSubmit: SubmitHandler<DefaultValuesSkuType> = ({ file }) => {
    createSKURequest({
      id,
      file,
    }).then(() => onCloseDrawer());
  };

  const isButtonDisabled = Object.keys(errors).length > 0;

  return (
    <DrawerCreate
      anchor="right"
      open={isDrawerOpen}
      onClose={onCloseDrawer}
    >
      <DrawerContent>
        <div className="header">
          <Typography
            variant="h5"
            sx={{ fontWeight: '600' }}
          >
            Загрузить SKU
          </Typography>
          <IconButton
            onClick={onCloseDrawer}
            sx={{ color: '#000' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="content">
          <Controller
            control={control}
            name="file"
            render={({ field }) => (
              <UploadFile
                onChange={field.onChange}
                textLabel="Файл SKU"
                helperText="xls, xlsx"
                textButton="Выбрать excel файл SKU"
                style={{ marginBottom: '24px' }}
                errors={errors.file}
              />
            )}
          />
          <Button
            disabled={isButtonDisabled}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            Загрузить
          </Button>
        </div>
      </DrawerContent>
    </DrawerCreate>
  );
};
